import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompass02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm0 2.2a.8.8 0 0 1 .8.8v1.6a.8.8 0 0 1-1.6 0V4a.8.8 0 0 1 .8-.8ZM6.909 5.777A.8.8 0 1 0 5.777 6.91L6.91 8.04A.8.8 0 1 0 8.04 6.909L6.91 5.777ZM4 11.2a.8.8 0 0 0 0 1.6h1.6a.8.8 0 0 0 0-1.6H4Zm14.4 0a.8.8 0 0 0 0 1.6H20a.8.8 0 0 0 0-1.6h-1.6Zm-2.44 4.76a.8.8 0 0 1 1.131 0l1.131 1.131a.8.8 0 1 1-1.13 1.132L15.96 17.09a.8.8 0 0 1 0-1.131Zm2.262-9.051a.8.8 0 1 0-1.13-1.132L15.96 6.91A.8.8 0 0 0 17.09 8.04l1.131-1.131ZM12.8 18.4a.8.8 0 0 0-1.6 0V20a.8.8 0 0 0 1.6 0v-1.6Zm-4.76-1.309A.8.8 0 0 0 6.91 15.96L5.777 17.09a.8.8 0 1 0 1.132 1.132L8.04 17.09Zm3.253-7.798a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414l2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgCompass02.displayName = 'Compass02';
export default SvgCompass02;
